// extracted by mini-css-extract-plugin
module.exports = {"component":"ContentWrapper_component__JYS_K","is-dark-theme":"ContentWrapper_is-dark-theme__ipige"};